import { useMemo, useState } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'
import { Header } from 'app/KinerjaShared/components/Header'
import { TablePenetapan } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/TablePenetapan'
import { useAPIGetPenetapanPegawai } from 'api/kinerja/tim-penilai-ps/penetapan'

const PAGE_SIZE = 10

export default function PegawaiListRatedByPPK() {
  const { basePath } = useBasePath()

  const [page, setPage] = useState(1)

  // Get Penetapan Pegawai List
  const { data: responseData, isFetching } = useAPIGetPenetapanPegawai({
    params: {
      offset: (page - 1) * PAGE_SIZE,
      limit: PAGE_SIZE,
      status: 'PPK_SENT',
    },
    options: {
      staleTime: 60 * 60 * 1000, // 1 hour
    },
  })
  const data = useMemo(() => responseData?.data, [responseData?.data])
  const meta = useMemo(() => responseData?.meta, [responseData?.meta])
  const showPagination = meta?.total > PAGE_SIZE
  const isPrintDisabled = (data?.pengawasSekolah ?? []).length === 0

  return (
    <div className="min-h-full px-8 pt-12 pb-8 bg-gray-10">
      <div className="pb-12 mx-auto max-w-7xl">
        <Header
          title="Penetapan Predikat Kinerja dari Pejabat Penilai Kinerja"
          className="mb-12 print:hidden"
        />

        <main>
          <div className="flex justify-between p-6 bg-white rounded-t-lg gap-x-2 flex-0 print:hidden">
            <Text variant="heading-md">
              Data sudah ditampilkan ke Pengawas Sekolah dan mungkin muncul
              secara berkala
            </Text>
            <Button
              variant="ghost"
              className="!text-sm h-fit gap-x-1"
              disabled={isPrintDisabled}
              onClick={() => {
                window.print()
              }}
            >
              <Icon
                fontSize="sm"
                color={isPrintDisabled ? 'disabled' : 'informational'}
              >
                print
              </Icon>
              Cetak
            </Button>
          </div>
          <TablePenetapan.Provider
            data={data}
            meta={meta}
            isFetching={isFetching}
          >
            <div className="space-y-4">
              <TablePenetapan.TableSendToEkin
                nextPageResolver={(pengawasSekolahId) =>
                  `${basePath}/penilai/penetapan/${pengawasSekolahId}`
                }
              />
              {showPagination && (
                <TablePenetapan.Pagination
                  totalItems={meta?.total}
                  pageSize={PAGE_SIZE}
                  currentPage={page}
                  onPageChange={setPage}
                  className="print:hidden"
                />
              )}
            </div>
          </TablePenetapan.Provider>
        </main>
      </div>
    </div>
  )
}
